import React, { useState } from "react";
import { Button, Card, Select, UploadingInput } from "../../../common";
import { RequestItem } from "./RequestItem";
import { useSupportTicketMutation } from "../../../../store/admin/adminApiSlice";
import { useSelector } from "react-redux";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { Modal } from "../../../common/Modal";
import { TicketRaisedSuccessfully } from "../../Dashboard/help/TicketRaisedSuccessfully";
import { uploadFilePath } from "../../../../constants/s3UploadPath";
import imageIcons from "../../../../assets/imageLogo.svg"
import imagePDF from "../../../../assets/imagePDF.svg"
import { ReactComponent as Close } from "../../../../assets/icons/close.svg";
import { uploadFileToS3 } from "../../../../utils/uploadFileToS3";

const supportTicketSubjects = [
  "Unable to access a company",
  "Unable to verify a company",
  "Payment Inquiry",
  "Product Assistance",
  "Technical Glitch",
  "Order Tracking",
  "Cancellation",
  "Website Navigation",
  "Complaint",
  "Other",
];

export const HelpAndSupport = () => {
  const [selectedSubject, setSelectedSubject] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [description, setDescription] = useState("");
  const [successMsg, setSuccessMessage] = useState("");
  const [error, setShowError] = useState(false);
  const [supportID, setSupport] = useState(0);
  const { userInfo, token } = useSelector((state) => state.auth);
  const [createSupportTicket, { isLoading }] = useSupportTicketMutation();
  const [isOpen, setIsOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const renderPreview = () => {
    if (uploadedFile.type.includes("image")) {
      return <div className="flex justify-center items-center h-full"><div className="flex justify-center flex-col items-center"><img src={imageIcons} alt="trade" width={"40px"} /><p>{uploadedFile.name}</p></div></div>;
    } else if (uploadedFile.type === "application/pdf") {
        return <div className="flex justify-center items-center h-full"><div className="flex justify-center flex-col items-center"><img src={imagePDF} alt="trade" width={"40px"} /><p>{uploadedFile.name}</p></div></div>;
    } else {
      return <p>Unsupported file type</p>;
    }
  };
  const handleFileSelect = (file) => {
    setUploadedFile(file);
    if (file && file.type.match("image.*")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
    }

  };
  const handleWorkingSubject = (e) => {
    setSelectedSubject(e.target.value);
  };

  const modalHandle = () => {
    setIsOpen(!isOpen);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedSubject === "") {
      setShowError(true);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("subject", selectedSubject);
      formData.append("message", description);
      formData.append("email_address", userInfo?.email);
      formData.append("individualID", userInfo?.individual[0].individualID);
      formData.append("status", "raised");
      if (uploadedFile) {
        const supportScreenshotUrl = await uploadFileToS3(
          uploadFilePath?.supportScreenshot,
          uploadedFile,
          token,
          userInfo?.id
        );
        formData.append("screenshot", supportScreenshotUrl?.url);
      }


      const data = {
        subject: selectedSubject,
        message: description,
        email_address: userInfo?.email,
        individualID: userInfo?.individual[0].individualID,
        status: "raised",
      };

      const res = await createSupportTicket({
        data: uploadedFile ? formData : data,
        token,
      }).unwrap();

      setSupport(res.supportID);
      if (res) {
        setSuccessMessage(
          `Thank You for contacting support! We will get back to your shortly.`
        );
        modalHandle();
        setDescription("");
        setSelectedSubject("");
      }
    } catch (error) {
    } finally {
      setShowError(false);
    }
  };

  return (
    <Card classes="w-full md:col-start-1 md:col-end-10 ">
      <h3 className="text-left text-f24 text-primary font-bold">
        Support Center
      </h3>
      <p className="text-left text-f16 text-secondarytwo mb-4">
        Reach out for solutions and raise tickets for platform-related issues.
      </p>

      {isOpen && (
        <Modal modalHandle={modalHandle}>
          <TicketRaisedSuccessfully close={modalHandle} supportID={supportID} />
        </Modal>
      )}

      <div className="bg-white rounded-md px-6 py-6 text-left">
        <h4 className="text-left text-f20 text-primary font-bold">
          Raise a ticket
        </h4>
        <p>Tell us the problem you are facing</p>
        <form className="mt-4 relative">
          <Select
            label="Subject"
            id="subject"
            value={selectedSubject}
            error={error}
            placeholder="Select a Subject"
            onChange={handleWorkingSubject}
          >
            <option value="">Select a subject</option>
            {supportTicketSubjects?.map((issue) => (
              <option key={issue} value={issue}>
                {issue}
              </option>
            ))}
          </Select>
          <label
            className="block mb-1 text-primary text-f14 font-semibold text-left"
          >
            Describe the problem you are facing (max 100 words)
          </label>
          <textarea
            id="message"
            rows="4"
            value={description}
            className="block p-2.5 w-full text-sm text-gray-900 bg-inputInterface rounded-lg border border-input focus:border-primary outline-none"
            placeholder="Enter a description..."
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          ></textarea>
          {uploadedFile ? (
            <div className="w-full h-36 overflow-hidden  rounded-lg relative">
              {renderPreview()}
              <button
                            className="absolute right-3 top-3 bg-orange-600	rounded-full"
                            onClick={() => {
                              setUploadedFile(null);
                              setPreviewImage(null);
                            }}
                          >
                            <Close />
                          </button>
            </div>
          ) : (
            <>
              <label
                className="block mb-1 text-primary text-f14 font-semibold text-left mt-4"
              >
                Upload Supporting screenshot (Optional)
              </label>
              <UploadingInput
                onFileSelect={handleFileSelect}
              /></>)}
          <Button
            onClick={handleSubmit}
            classes="w-full p-2 bg-primary text-white rounded text-f18 mt-6 flex justify-center"
          >
            {isLoading ? <Spinner /> : "Submit Ticket"}
          </Button>
        </form>
        {successMsg !== "" && <div>{successMsg}</div>}
      </div>

      {userInfo?.individual[0]?.individualSupport.length > 0 && <div className="flex flex-wrap gap-3">
        <div className="my-6 w-full">
          <div className="mt-6">
            <div className="px-2 py-4 bg-white rounded-lg">
              <div className="flex justify-between p-3">
                <div className="text-f20 uppercase text-primary font-semibold">
                  My Complaints
                </div>
              </div>
              <hr />
              <div className="divide-y">
                {userInfo?.individual[0]?.individualSupport?.map((item) => (
                  <RequestItem request={item} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>}
    </Card>
  );
};
